import { useEffect, useState } from 'react';
import { WOOSMAP_BASE_URL, WOOSMAP_DEFAULT_STYLE, WOOSMAP_DEFAULT_ZOOM, WOOSMAP_ID } from '@headless-workspace/config';
import { ClientEnvKey, useClientData } from '@headless-workspace/domain/common/client';
import { useScript } from 'usehooks-ts';

export const useMap = (root: HTMLElement): woosmap.map.Map | undefined => {
    const [map, setMap] = useState<woosmap.map.Map>();
    const { getClientEnvVariable } = useClientData();
    const woosmapStatus = useScript(`${WOOSMAP_BASE_URL}${getClientEnvVariable(ClientEnvKey.WoosmapKey)}`, {
        removeOnUnmount: true,
        id: WOOSMAP_ID,
    });

    useEffect(() => {
        if (woosmapStatus === 'ready' && !map) {
            const map = new woosmap.map.Map(root, {
                zoom: WOOSMAP_DEFAULT_ZOOM,
            });
            const storesOverlay = new woosmap.map.StoresOverlay(WOOSMAP_DEFAULT_STYLE);
            storesOverlay.setMap(map);
            setMap(map);
        }
    }, [map, root, woosmapStatus]);

    return map;
};
